/**
 * Product Filter Clear All
 * @module productFilterClearAll
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'productFilterClearAll';
export const DEFAULTS = {};
const ZeroChecked = ($checkboxes) => $checkboxes.filter(':checked').length === 0;

const clearAllVisibility = ($checkboxes, $clearButton) => {
  const isZeroChecked = ZeroChecked($checkboxes);

  if (isZeroChecked) {
    $clearButton.hide();
  } else {
    $clearButton.show();
  }
};

const onChangeListener = ($checkboxes, $clearButton) => $checkboxes.on('change', () => clearAllVisibility($checkboxes, $clearButton));

/**
 * Initializes productFilterClearAll.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
export default function productFilterClearAll(container) {
  const $container = $(container);
  const $checkboxes = $container.find('input[type="checkbox"]');
  const $clearButton = $('.js-product-filter-clear-all-button');

  $clearButton.on('click', () => {
    $checkboxes.each((index, checkbox) => {
      if (checkbox.checked) {
        $(checkbox).prop('checked', false).trigger('change');
      }
    });
  });

  clearAllVisibility($checkboxes, $clearButton);
  onChangeListener($checkboxes, $clearButton);
}

registerJQueryPlugin(PLUGIN_NAME, productFilterClearAll);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-filter-clear-all.js